import { RoverTheme } from '@rover/types';

// defined here and added in each theme file,
// because it is annoying difficult to get style-dictionary to generate it correctly
type Breakpoints = [string, string, string];
export const breakpoints: Breakpoints = ['768px', '992px', '1200px'];

// there are slight differences in the types between web and rxn, and this typeof helps smooth them out
export type ThemeWithBreakpoints = RoverTheme & {
  breakpoints: Breakpoints;
};
